module.exports = __webpack_public_path__ + "static/media/msg_illus.ba0729c4.svg";